
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/station-de-ski",
      function () {
        return require("private-next-pages/station-de-ski.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/station-de-ski"])
      });
    }
  